export const APP_NAME = '';

export const DEFAULT = 'default';
export const SUCCESS = 'success';
export const INFO = 'info';
export const WARNING = 'warning';
export const DANGER = 'danger';
export const CUSTOM = 'custom';

export const NOTIFY_TIMEOUT = 3000;
